import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import apiInstance from '../../services/ServiceApi';
import { Button, TextField } from '@mui/material';

function EmpresaSelect(props) {
    const [empresas, setEmpresas] = useState([]);
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    const [newEmpresa, setNewEmpresa] = useState("");

    useEffect(() => {
        apiInstance.get('/empresas/')
            .then(response => {
                setEmpresas(response.data);
            })
            .catch(error => {
                console.error("Error al obtener las empresas:", error);
            });
    }, []);

    const handleSelectChange = (event) => {
        const empresa = empresas.find(e => e.id === event.target.value);
        setSelectedEmpresa(empresa);

        props.onEmpresaSelected(empresa);
    };

    const handleAddEmpresa = () => {
        apiInstance.post('/empresas/', { empresa: newEmpresa })
            .then(response => {
                // Actualizamos la lista de empresas con la nueva empresa
                setEmpresas([...empresas, response.data]);
                setNewEmpresa("");  // Limpiamos el input
            })
            .catch(error => {
                console.error("Error al agregar la empresa:", error);
            });
    };
    return (
        <div>
            <FormControl fullWidth margin="normal">
                <InputLabel>Seleccione una o varias Empresa</InputLabel>
                <Select
                    value={selectedEmpresa ? selectedEmpresa.id : ""}
                    onChange={handleSelectChange}
                >
                    {empresas.map(empresa => (
                        <MenuItem key={empresa.id} value={empresa.id}>
                            {empresa.empresa}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {/* Campo para agregar nueva empresa */}
            <FormControl fullWidth margin="normal">
                <TextField
                    label="Nueva Empresa" 
                    value={newEmpresa}
                    onChange={(e) => setNewEmpresa(e.target.value)} 
                />
            </FormControl>
            
            {/* Botón para agregar empresa */}
            <Button 
                variant="contained" 
                color="primary" 
                disabled={!newEmpresa.trim()} // Se habilita solo si hay texto en el input
                onClick={handleAddEmpresa}
            >
                Agregar Empresa
            </Button>

            {selectedEmpresa && <p>Empresa seleccionada: {selectedEmpresa.empresa}</p>}
        </div>
    );
}

export default EmpresaSelect;